import { FormGroup } from 'arag-ui-lib';

const StagedStep3 = (props) => {
  return (
    <div>
      <FormGroup
        labelSize="col-sm-3"
        inputSize="col-sm-5"
        label="Notes"
        variant="textarea"
        inputProps={{
          required: false,
          onChange: (evt) => {
            props.changeStagedPremiumFormData(
              evt.target.name,
              evt.target.value
            );
          },
          rows: 4,
          name: 'notes',
          value: props.stagedPremiumsWizard.notes,
        }}
      />
      <FormGroup
        labelSize="col-sm-3"
        inputSize="col-sm-5"
        label="Comments"
        variant="textarea"
        inputProps={{
          required: false,
          rows: 4,
          onChange: (evt) => {
            props.changeStagedPremiumFormData(
              evt.target.name,
              evt.target.value
            );
          },
          name: 'comments',
          value: props.stagedPremiumsWizard.comments,
        }}
      />
      <FormGroup
        labelSize="col-sm-3"
        inputSize="col-sm-5"
        label="Coverage Types"
        variant="select"
        inputProps={{
          onChange: (evt) => {
            props.changeStagedPremiumFormData(
              evt.target.name,
              parseInt(evt.target.value)
            );
          },
          options: [
            { key: '', label: '' },
            ...props.stagedPremiumsWizard.coveragesOptions.map((c) => {
              return { key: c.id, label: c.name };
            }),
          ],
          value: props.stagedPremiumsWizard.selectedCoverageType,
          name: 'selectedCoverageType',
          required: true,
        }}
      />
      <FormGroup
        labelSize="col-sm-3"
        inputSize="col-sm-5"
        label="Deductible"
        variant="select"
        inputProps={{
          onChange: (evt) => {
            props.changeStagedPremiumFormData(
              evt.target.name,
              parseInt(evt.target.value)
            );
          },
          options: [
            { key: '', label: '' },
            ...props.stagedPremiumsWizard.deductiblesOptions.map((c) => {
              return { key: c.id, label: c.name };
            }),
          ],
          value: props.stagedPremiumsWizard.selectedDeductible,
          name: 'selectedDeductible',
          required: true,
        }}
      />
      <FormGroup
        labelSize="col-sm-3"
        inputSize="col-sm-5"
        label="Endorsements"
        variant="select"
        inputProps={{
          onChange: (evt) => {
            props.changeStagedPremiumFormData(
              evt.target.name,
              parseInt(evt.target.value)
            );
          },
          options: [
            { key: '', label: '' },
            ...props.stagedPremiumsWizard.endorsementsOptions.map((c) => {
              return { key: c.id, label: c.name };
            }),
          ],
          value: props.stagedPremiumsWizard.selectedEndorsement,
          name: 'selectedEndorsement',
          required: true,
        }}
      />
      {props.isApplicationPremium == false && (
        <FormGroup
          labelSize={'col-sm-3'}
          inputSize={'col-sm-5'}
          label={'Valid from'}
          variant={'date'}
          inputProps={{
            required: true,
            name: 'validFrom',
            dateInputProps: {
              minDate: new Date(),
              onChange: (evt) => {
                props.changeStagedPremiumFormData('validFrom', evt);
              },
              autoComplete: 'off',
              dateFormat: 'dd/MM/yyyy',
              selected: props.stagedPremiumsWizard.validFrom,
              placeholderText : 'DD/MM/YYYY'
            },
          }}
        />
      )}
      {props.isApplicationPremium == false && (
        <FormGroup
          labelSize={'col-sm-3'}
          inputSize={'col-sm-5'}
          label={'Valid until'}
          variant={'date'}
          inputProps={{
            required: false,
            name: 'validUntil',
            value: props.stagedPremiumsWizard.validUntil,
            dateInputProps: {
              minDate: props.stagedPremiumsWizard.validFrom,
              dateFormat: 'dd/MM/yyyy',
              onChange: (evt) => {
                props.changeStagedPremiumFormData('validUntil', evt);
              },
              autoComplete: 'off',
              selected: props.stagedPremiumsWizard.validUntil,
              placeholderText : 'DD/MM/YYYY'
            },
          }}
        />
      )}
    </div>
  );
};
export default StagedStep3;
